/**
 * @generated SignedSource<<feaa0449efe4668e6572604f4523480c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Image_sortedPhoto$data = {
  readonly alt: string | null;
  readonly masterOrZoomPath: string | null;
  readonly " $fragmentType": "Image_sortedPhoto";
};
export type Image_sortedPhoto$key = {
  readonly " $data"?: Image_sortedPhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"Image_sortedPhoto">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Image_sortedPhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterOrZoomPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alt",
      "storageKey": null
    }
  ],
  "type": "ItemPhoto",
  "abstractKey": null
};

(node as any).hash = "387189230bf9f758060aaec2d4c5adfb";

export default node;
